import React from "react"
import LoaderAnimation from "../Loader/Loader"

import { Grid,Backdrop } from "@mui/material"

const LoaderModal = ({ ShowLoader }) => {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: 1500 }} open={ShowLoader} >
      <Grid item display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
        <LoaderAnimation />
        <h4 className="m-0 p-0">Loading, Please Wait...</h4>
      </Grid>
    </Backdrop>

  )
}

export default LoaderModal